import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

export const availabilityClient = axios.create({
  baseURL: readFromEnv(Env.LogisticsAvailabilityServiceUrl),
})
